export const MEASUREMENT_SYSTEM_METRIC = 'metric';
export const MEASUREMENT_SYSTEM_IMPERIAL = 'imperial';

export const KG = 'kg';
export const LB = 'lb';